import { Button, Dropdown, Menu } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { createComponentStore, useStoreState } from "easy-peasy";
import React, { useEffect } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { ParameterStoreModel } from "store/models/parameters/general-parameter";
const useRentableAreaTypeStore = createComponentStore(
  ParameterStoreModel("rentableareatypes")
);

export default function NewRentableAreaButton({ ...props }) {
  const [store, actions] = useRentableAreaTypeStore();
  const { abilities } = useStoreState((state) => state.auth);
  const match = useRouteMatch();
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.NEW_RECORD,
    "Kiralanabilir Alanlar"
  );

  useEffect(() => {
    actions.fetch();
  }, []);

  return (
    <Dropdown
      trigger="hover"
      disabled={!IsAuthorized}
      placement="bottomRight"
      overlay={
        <Menu>
          {store.data.map((item) => (
            <Menu.Item key={item.id}>
              <Link to={`${match.path}/yeni/${item.id}`}>
                {item.description}
              </Link>
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button>Yeni Kiralanabilir Alan</Button>
    </Dropdown>
  );
}
